/* esm.sh - index-array-by@1.4.2 */
export * from "/*index-array-by@1.4.2/esnext/index-array-by.mjs";
export { default } from "/*index-array-by@1.4.2/esnext/index-array-by.mjs";
